module.exports = __webpack_public_path__ + "img/1.e07d7c08.png";